import Product from "@/views/dashboard/models/Product";
export default {
  create_product_btn: 'create new product',
  create_product_by_ai_btn: 'import product',
  filter: {
    search: {
      placeholder: 'Filter products ...'
    },
    country: {
      placeholder: 'All countries'
    },
    warehouse: {
      placeholder: 'All warehouses'
    },
    sort: {
      new_to_old: 'New to old',
      old_to_new: 'Old to new'
    },
    sort_archived: {
      show_archived: 'Show archived',
      hide_archived: 'Hide archived'
    }
  },
  tabs: {
    product_id: 'Product id : {id}',
    overview: 'Overview',
    inventory: 'Inventory',
    inventory_history: 'Inventory history',
    inventory_overview: 'Inventory overview'
  },
  product_item: {
    advertiser: 'Advertiser',
    warehouse: 'Warehouse',
    available_in: 'Available in',
    buttons: {
      overview: 'Overview',
      add_inventory: 'Add inventory',
      edit: 'Edit',
      delete: 'Delete'
    }
  },
  dialogs: {
    delete: {
      title: 'Delete Product',
      content: 'Pausing or deleting the product will impact the Sale pages attached to it. Are you sure you want to proceed ?'
    }
  },
  ai_form: {
    description: 'We will use AI to scan the product URL and we will create a good description with product images.',
    select_platform: 'Please select the platform of the product and insert the URL.',
    coming_soon: 'Coming Soon',
    fields: {
      description_language: {
        title: 'Description Language',
        options: {
          ar: 'Arabic',
          en: 'English',
          fr: 'French',
          es: 'Spanish',
          it: 'Italian'
        }
      }
    },
    buttons: {
      plan_incentives_text: '{tries} Products imported!',
      plan_incentives_tries_left: '{tries} left',
      plan_incentives_button: 'Upgrade Now',
      import_product: 'Import Product',
      close: 'Close'
    }
  },
  form: {
    variant_types: {
      [Product.SINGLE_VARIANT_TYPE]: 'No variant',
      [Product.MULTIPLE_VARIANT_TYPE]: 'Add variant'
    },
    toggle_form: 'Click here to create a product',
    create_product: {
      title: 'Create Product',
      subtitle: 'Create new product'
    },
    update_product: {
      title: 'Update Product',
      subtitle: 'Update product'
    },
    create_btn: 'Create Product',
    save_btn: 'Save Product',
    cancel_btn: 'Cancel',
    duplicate_btn: 'Duplicate Product',
    edit_btn: 'Edit Product',
    delete_btn: 'Delete Product',
    step_one: 'Step 1 : Product Info',
    step_two: 'Step 2 : Inventory info (optional)',
    step_two_variant: 'Step 2 : Setup variants',
    variation_form: {
      table_filter: {
        select: 'select',
        all: 'all',
        none: 'none'
      },
      fields: {
        variation_name: 'Variant name',
        variation_options: {
          title: 'Variant options',
          hint: 'You can choose an option from the list or add a new one.'
        }
      },
      table: {
        image: 'Image',
        options: 'Options',
        sku: 'Sku',
        quantity: 'Quantity',
        unit_price: 'Unit Price',
        status: 'Status'
      },
      buttons: {
        add_variant: 'Add another variant'
      }
    },
    fields: {
      image: {
        title: 'Main Image'
      },
      name: {
        title: 'Product name',
        placeholder: 'Type your product name'
      },
      description: {
        title: 'Product description',
        placeholder: 'Type product description'
      },
      gallery: {
        title: 'Product Gallery Images',
        placeholder: 'add some images to the product gallery'
      },
      status: {
        title: 'Product Status'
      },
      private_note: {
        title: 'Private notes',
        placeholder: 'Type your private notes'
      },
      sku: {
        title: 'Product Sku',
        placeholder: 'Type a unique ID for your product'
      },
      advertiser: {
        title: 'Advertiser',
        placeholder: 'No advertiser',
        no_advertiser_option: 'No advertiser'
      },
      warehouse: {
        title: 'Warehouse',
        placeholder: 'Select the warehouse'
      },
      country: {
        title: 'Country of sale',
        tooltip: 'Where do you want to sell this product ?',
        placeholder: 'Select the sale country'
      },
      product_type: {
        title: 'Product Type'
      },
      inventory_quantity: {
        title: 'Inventory quantity',
        placeholder: 'Set the inventory quantity'
      },
      inventory_cost: {
        title: 'Inventory Unit Cost',
        placeholder: 'Set the inventory unit cost'
      },
      add_variation: {
        options: {
          add_variant: 'Add Variant',
          no_variant: 'No Variant'
        }
      }
    }
  },
  product_overview: {
    advertiser: 'Advertiser',
    product_doesnt_have_advertiser: 'this product doesn\'t have an advertiser',
    short_description: 'Short description',
    status: 'Status',
    warehouse: 'Warehouse',
    available_in: 'Available in',
    variations: 'Variations',
    private_note: {
      title: 'Private notes',
      not_found: 'No notes has been added.'
    }
  },
  inventory: {
    dialogs: {
      delete: {
        title: 'Delete Inventory',
        content: 'Pausing or deleting the inventory will impact the elements attached to it. Are you sure you want to proceed ?'
      }
    },
    form: {
      fields: {
        variation: {
          title: 'Variation'
        },
        country: {
          title: 'Country',
          placeholder: 'Select a country'
        },
        quantity: {
          title: 'Quantity (optional)',
          placeholder: 'Set the quantity'
        },
        unitary_cost: {
          title: 'Unit Cost (optional)',
          placeholder: 'Set the unit cost'
        }
      },
      buttons: {
        create: 'Create Inventory'
      }
    },
    table: {
      date: 'Date',
      country: 'Country',
      sku: 'Sku',
      Quantity: 'Quantity',
      cost: 'Cost',
      unit_cost: 'Unit cost',
      actions: 'Actions'
    }
  },
  inventory_history: {
    table: {
      date_time: 'Date and time (N-O)',
      country: 'Country',
      product_sku: 'Product SKU',
      quantity: 'Quantity',
      cost: 'Cost',
      unit_cost: 'Unit Cost',
      deleted_at: 'Deleted at',
      actions: 'Actions'
    }
  },
  inventory_overview: {
    table: {
      sku: 'Product SKU',
      country: 'Country',
      available_quantity: 'Available Quantity',
      last_daily_sales: 'Last daily sales',
      last_weekly_sales: 'Last weekly sales',
      out_of_stock: 'Out of stock in'
    }
  }
};